/* eslint-disable no-plusplus */
/* eslint-disable indent */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-use-before-define */
/* eslint-disable default-case */
/* eslint-disable func-style */
/**
 * Opening times - Found on find a dealer home page
 */
((document) => {
  /**
   * Set the spinner initial state
   * {boolean}
   */
  let isSpinnerVisible = false;

  /**
   * Get the location ref from the page, used on enquire thank you pages
   * @const {?string}
   */
  const vehicleLocnRef = window.vehicleLocnRef || null;

  /**
   * Thank you page container
   * {HTMLElement} div
   */
  const thankYouTimesContainer = document.querySelector('.js-thank-you-times');

  const isTabletandAbove = window.matchMedia('(min-width: 881px)');

  /**
   * Gets the page type by checkigng the href against a given string
   * @param {string} type - The type of of page it is
   * @returns {boolean} true of false based on the page
   */
  const getPageType = (type) => window.location.href.includes(type);

  /**
   * Function to map the correct department name from the response
   * @param {string} name The name of the department
   * @returns The converted label
   */
  const getDepartmentName = (name) => {
    let label;
    switch (name) {
      case 'newsales':
        label = 'New Sales';
        break;
      case 'usedsales':
        label = 'Used Sales';
        break;
      case 'service':
        label = 'Service';
        break;
      case 'parts':
        label = 'Parts';
        break;
    }
    return label;
  };

  /**
   * Build a custom link to append to the opening hours
   * @param {string} linkText - The text we want to display inside the link
   * @returns linkContainer - The link container we've built
   */
  const buildCustomLink = (linkText) => {
    const link = `<a class="body-link margin-top-15" href="/ceo-announcement/" target="_blank">${linkText}</a>`;
    const linkContainer = document.createElement('div');
    linkContainer.classList.add('margin-top-15', 'text-align--left');
    linkContainer.innerHTML = link;
    return linkContainer;
  };

  /**
   * Generat the thank you page tables
   * @param {(string|Array[])} openingTimes - The available opening times
   * @param {boolean} hasSpecialTimes - Whether the times have bank holidays
   */
  const generateThankYouPageTimes = (openingTimes, hasSpecialTimes) => {
    const spinner = `
      <div class="spinner-container spinner-container--small js-spinner" style="height: 170px; margin: auto; position: relative;">
        <div class="spinner-fade spinner-fade--center" style="width: 8em; height: 8em;"></div>
      </div>`;

    const spinnerDiv = document.createElement('div');
    spinnerDiv.innerHTML = spinner;

    if (!isSpinnerVisible) {
      thankYouTimesContainer.appendChild(spinnerDiv);
      isSpinnerVisible = true;
    }

    if (openingTimes && openingTimes.length) {
      let table;
      const openDayType = hasSpecialTimes ? 'specialDays' : 'openDays';
      openingTimes.forEach((time) => {
        const department = time.deptDsc;
        // If parts or service return
        if (department === 'parts' || department === 'service') return;
        switch (true) {
          case department === 'newsales' && getPageType('new'):
            table = generateTables(time, openDayType, department);
            break;
          case department === 'usedsales' && getPageType('used'):
            table = generateTables(time, openDayType, department);
            break;
          default:
            table = generateTables(time, openDayType, 'usedsales');
        }
      });

      // Set a small timeout to show the spinner
      // then set the innerHTML with the price
      setTimeout(() => {
        spinnerDiv.replaceWith(table);
      }, 300);
    }
  };

  /**
   * Render the opening times tables for the location
   * @param {object[]} openingTimes The opening times for each department
   */
  const renderTables = (openingTimes) => {
    const hasSpecialTimes = openingTimes && !!openingTimes[0].specialDays;

    // If on that thank you page, generate the times then return
    if (thankYouTimesContainer) {
      // Clear the innerHTML immendiately
      thankYouTimesContainer.innerHTML = '';
      generateThankYouPageTimes(openingTimes, hasSpecialTimes);
      return;
    }

    const openingTimesContainer = document.querySelector('.OpeningTimes');
    const cardContainer = document.querySelector('.js-card--thin');
    const preselected = document.querySelector('.TextBox');
    const tooltipContent = document.createElement('div');
    const isChristmasTimes =
      hasSpecialTimes &&
      openingTimes[0].specialDays.some((e) =>
        /New Years|Boxing|Christmas|25th December/.test(e.openDay),
      );
    const isEasterTimes =
      hasSpecialTimes &&
      openingTimes[0].specialDays.some((e) => /Good Friday|Easter/.test(e.openDay));
    const isBankHoliday =
      hasSpecialTimes &&
      openingTimes[0].specialDays.some((e) => /Bank|Jubilee|Mourning/.test(e.openDay));
    const isBankHolidayCustom =
      hasSpecialTimes && openingTimes[0].specialDays.some((e) => e.openDay.includes('Mourning'));
    const bankHolidayLabel = isBankHolidayCustom
      ? 'National Day of Mourning Closed'
      : 'Bank Holiday Opening Hours';

    // If the special times are present
    if (hasSpecialTimes) {
      const h4 = document.createElement('h4');
      h4.className = 'text-align--left';
      h4.innerHTML = getDepartmentName(preselected.value);

      preselected.addEventListener('change', () => {
        h4.innerHTML = getDepartmentName(preselected.value);
      });
      tooltipContent.appendChild(h4);
    }

    tooltipContent.className =
      'tooltip__content text-size--smaller font--regular text--black margin-bottom-0';
    tooltipContent.style.background = '#FFFFFF';
    tooltipContent.style.left = '0';
    tooltipContent.style.width = '100%';

    const specialTimesContainer = document.createElement('div');
    specialTimesContainer.className = 'OpeningTimes column--two-cell column--one-mobile';

    const button = document.createElement('button');

    button.className = 'btn btn--primary tooltip tooltip--top-left';
    button.style.background = '#DCF2E7';
    button.style.borderColor = '#DCF2E7';
    button.style.marginLeft = '1.875em';
    button.style.color = '#18AD56';
    button.style.width = 'auto';

    const content = `
      ${
        isEasterTimes
          ? `<svg class="icon margin-right-5" style="vertical-align: middle; margin-bottom: 0.15em;" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512">
            <path fill="currentColor" d="M192 0C85.1 0 0 214 0 320s85.1 192 192 192c105.1 0 192-86 192-192S297.1 0 192 0zM192 464c-79.38 0-144-64.63-144-144c0-117.4 90.63-272 144-272s144 154.6 144 272C336 399.4 271.4 464 192 464zM168 103.1c-7.299 0-14.11 3.262-18.7 8.949C113.1 156.8 76.34 238.6 76.34 304c0 13.23 10.77 24 24 24c13.24 0 24-10.77 24-24c0-52.42 31.7-122.1 62.35-160.9c8.303-10.29 6.688-25.43-3.596-33.75C178.8 105.9 173.5 103.1 168 103.1z"/>
          </svg>`
          : isChristmasTimes
            ? `<svg class="icon margin-right-5" style="vertical-align: middle; margin-bottom: 0.15em;" aria-hidden="true" focusable="false" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                <path fill="currentColor" d="M232 256c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm80 96c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm190.1 82.8l-66.5-87c10.6-4.8 19.4-13.3 24.3-24.4 7.7-17.4 4.4-37.6-8.4-51.7L338 146.8l12.4-6.2c10.8-5.4 17.7-16.5 17.7-28.6s-6.8-23.2-17.7-28.6l-43.8-21.9-21.9-43.8C279.2 6.8 268.1 0 256 0s-23.2 6.8-28.6 17.7l-21.9 43.8-43.8 21.9C150.8 88.8 144 99.9 144 112s6.8 23.2 17.7 28.6l12.4 6.2L60.5 271.7c-12.8 14.1-16.1 34.3-8.4 51.7 4.9 11.1 13.7 19.6 24.3 24.4l-66.5 87c-11.1 14.5-13 34.1-4.9 50.4 8.1 16.4 24.8 26.7 43 26.7h416c18.3 0 34.9-10.4 43-26.7 8.1-16.3 6.2-35.9-4.9-50.4zM236.5 99.6c3.1-1.5 5.6-4.1 7.2-7.2L256 67.8l12.4 24.7c1.5 3.1 4.1 5.6 7.2 7.2l24.7 12.4-24.7 12.4c-3.1 1.5-5.6 4.1-7.2 7.2L256 156.2l-12.4-24.7c-1.5-3.1-4.1-5.6-7.2-7.2L211.8 112l24.7-12.4zM48 464l122.4-160H96l116.3-127.9 15.1 30.2c5.4 10.8 16.5 17.7 28.6 17.7s23.2-6.8 28.6-17.7l15.1-30.2L416 304h-74.4L464 464H48z"></path>
              </svg>`
            : ''
      }
      ${
        isEasterTimes
          ? 'Easter Opening Hours'
          : isChristmasTimes
            ? 'Christmas Opening Hours'
            : isBankHoliday
              ? bankHolidayLabel
              : 'Special Opening Hours'
      }
      <svg class="icon margin-left-5" style="vertical-align: middle; margin-bottom: 0.1em;">
        <use xlink:href="#globalInfoCircle"></use>
      </svg>
    `;

    button.innerHTML = content;

    if (!openingTimesContainer) {
      vm.debug.error(new Error('OpeningTimes container was not found'));
      return;
    }

    const fragmentTables = document.createDocumentFragment();
    const specialFragmentTables = document.createDocumentFragment();

    // Loop through all the times and generate a table for each of the departments
    if (openingTimes && openingTimes.length) {
      for (let i = 0, len = openingTimes.length; i < len; i++) {
        const table = generateTables(openingTimes[i], 'openDays', preselected.value);

        fragmentTables.appendChild(table);

        if (hasSpecialTimes) {
          const specialTimesTable = generateTables(
            openingTimes[i],
            'specialDays',
            preselected.value,
          );
          specialTimesContainer.appendChild(specialTimesTable);
          tooltipContent.appendChild(specialTimesContainer);
          button.appendChild(tooltipContent);
          specialFragmentTables.appendChild(button);
        }
      }

      // If there's a bank holiday custom time
      if (isBankHolidayCustom) {
        tooltipContent.append(buildCustomLink('For more information'));
      }
    }

    // Empty any previous rendered content and render it
    openingTimesContainer.textContent = '';
    openingTimesContainer.appendChild(fragmentTables);

    if (hasSpecialTimes && cardContainer) {
      cardContainer.parentNode.insertBefore(specialFragmentTables, cardContainer);
      const afterStyle = document.head.appendChild(document.createElement('style'));
      afterStyle.innerHTML =
        '.btn--primary .tooltip__content:after { border-color: #ffffff transparent !important; left: 240px !important; }';

      const tooltipWidth = isBankHolidayCustom ? '105%' : '220%';

      if (isTabletandAbove.matches) {
        tooltipContent.style.minWidth =
          isEasterTimes || isBankHolidayCustom ? tooltipWidth : '200%';
        tooltipContent.style.padding = '20px';
      } else {
        tooltipContent.style.minWidth = isEasterTimes ? '112%' : '105%';
        tooltipContent.style.padding = '15px';
      }

      isTabletandAbove.addEventListener('change', (e) => {
        if (e.matches) {
          tooltipContent.style.minWidth =
            isEasterTimes || isBankHolidayCustom ? tooltipWidth : '200%';
          tooltipContent.style.padding = '20px';
        } else {
          tooltipContent.style.minWidth = isEasterTimes ? '112%' : '105%';
          tooltipContent.style.padding = '15px';
        }
      });
    }
  };

  /**
   * Generate a table with the opening time for each service (used/new/services/etc...)
   * @param {object} openingTime The opening time object of the location
   * @param {string} type The type of opening times - special (xmas) or normal
   * @param {string} preselected The preselected id to display
   */
  const generateTables = (openingTime, type, preselected) => {
    // Generate the table and add class/id
    const table = document.createElement('table');
    table.className = 'opening-times-table table--thin text-align--left text-size--small';
    table.style.display = preselected === openingTime.deptDsc ? 'table' : 'none';
    table.id = openingTime.deptDsc;

    const tBody = document.createElement('tbody');

    // Normal days opening times
    if (type === 'openDays') {
      if (openingTime.openDays) {
        openingTime.openDays.forEach((day) => {
          tBody.innerHTML += `
            <tr>
            <td class="text--ellipsis">${day.openDay}</td>
            <td>${day.openTimes}</td>
            </tr>
          `;
        });

        table.appendChild(tBody);
        return table;
      }
      // Special days openign times
    } else if (type === 'specialDays') {
      if (openingTime.specialDays) {
        openingTime.specialDays.forEach((day) => {
          tBody.innerHTML += `
            <tr>
            <td class="text--ellipsis">${day.openDay}</td>
            <td>${day.openTimes}</td>
            </tr>
          `;
        });

        table.appendChild(tBody);
        return table;
      }
    }
    return table;
  };

  /**
   * Get the opening times of a dealership location based on the reference
   * @param {string} locationRef The location's reference
   */
  function getOpeningTimes(locationRef) {
    return axios
      .get(`/content/api/json_dealer.p?locnref=${locationRef}`)
      .then((response) => response.data.locationDetail.openingTimes)
      .catch((err) => {
        vm.debug.error(err);
      });
  }

  /**
   * Handle the selection change from the TextBox select element
   */
  function handleSelectionChange() {
    // Get the current and new displayed tables
    const currentDisplayedTable = document.querySelectorAll(
      '.OpeningTimes .table--thin[style*="table"]',
    );
    const newDisplayedTable = document.querySelectorAll(`#${this.value}`);

    // Check if they exist and hide/show
    if (currentDisplayedTable && newDisplayedTable) {
      currentDisplayedTable.forEach((table) => {
        table.style.display = 'none';
      });

      newDisplayedTable.forEach((newTable) => {
        newTable.style.display = 'table';
      });
    }
  }

  /**
   * Intialize and render all the opening times tables
   */
  const initialize = () => {
    const locnRefInput = document.querySelector('[name=locnRef]');
    const locnRef = locnRefInput ? locnRefInput.value : vehicleLocnRef.locnRef;

    if (locnRef) {
      getOpeningTimes(locnRef).then(renderTables);

      // Add a change event listener to text box selection element
      if (locnRefInput) {
        const textBoxSelection = document.querySelector('.TextBox');
        textBoxSelection.addEventListener('change', handleSelectionChange);
      }
    } else {
      vm.debug.error(new Error('Location ref input was not found'));
    }
  };

  // Initialize the times on page load
  vm.onload(initialize);
})(document);
